import React from 'react';
import { Form, Input } from 'antd';

const FormInput = ({ name, placeholder, type = 'text', width = '80%', passClass }) => (
  <Form.Item
    name={name}
    rules={[
      {
        required: true,
        message: `Please input your ${placeholder.toLowerCase()}!`,
      },
    ]}
    className="mb-1"
    style={{ width }} // Apply width here
  >
    {type === 'password' ? (
      <Input.Password
        placeholder={placeholder}
        className="p-2 border border-[#000000]"
      />
    ) : (
      <Input
        placeholder={placeholder}
        type={type}
        className={`p-2 border ${passClass ? passClass : `border-[#000000]`}`}
      />
    )}
  </Form.Item>
);

export default FormInput;
